import React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    getChannelActiveStatuses as GetChannelActiveStatusesQuery,
    getChannelActiveStatusesVariables as GetChannelActiveStatusesQueryVariables,
} from 'nutshell-graphql-types';

import GET_CHANNEL_ACTIVE_STATUSES from '../queries/get-channel-active-statuses.graphql';

const POLL_INTERVAL_MILLISECONDS = 10000; // 10 seconds

export const useGetChannelActiveStatuses = (input: {channelIds: string[]}) => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetChannelActiveStatusesQuery, GetChannelActiveStatusesQueryVariables>(
        GET_CHANNEL_ACTIVE_STATUSES,
        {
            variables: {channelIds: input.channelIds},
            fetchPolicy: 'network-only',
        }
    );

    const channelActiveStatuses = data ? data.channelActiveStatuses : null;

    React.useEffect(() => {
        if (channelActiveStatuses) {
            const tick = () => {
                refetch();
            };

            const id = setInterval(tick, POLL_INTERVAL_MILLISECONDS);

            return () => clearInterval(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channelActiveStatuses]);

    return {
        channelActiveStatuses: channelActiveStatuses,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
